import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Card, CardContent, CardActions, Grid, Typography, Button, CardHeader } from '@material-ui/core';
import { genfunction } from 'helpers';
import ReactHtmlParser from 'react-html-parser';

const { MembershipPackageDefaultImage } = window['runConfig'];

const useStyles = makeStyles(theme => ({
  root: {},
  card: {
    "&:hover": {
      transform: 'scale(1.02)',
      WebkitTransform: 'scale(1.02)',
      border: "solid 2px",
      borderRadius: "5px",
      borderTop: "0px",
      cursor: 'pointer'
    }
  },
  tourheaderbox: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText
  },
  img: {
    width: "100%",
    objectFit: "cover",
    objectPosition: "bottom"
  },
  btnAlign: {
    marginTop: "20px",

    [theme.breakpoints.up('sm')]: {
      width: '50%'
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  highlightActiveMembershipPackage: {
    border: 'solid 7px ' + theme.palette.primary.main,
    boxShadow: "0 5px 10px rgba(0, 0, 0, .8)"
  },
  ribbon: {
    width: "150px",
    height: "150px",
    overflow: "hidden",
    position: "absolute",
    zIndex: 1000,
    right: "0px"
  },
  ribbonSpan: {
    padding: "15px 0",
    display: "block",
    width: "200px",
    backgroundColor: theme.palette.success.dark,
    boxShadow: "0 5px 10px rgba(0, 0, 0, .1)",
    color: theme.palette.success.contrastText,
    textShadow: "0 1px 1px rgba(0, 0, 0, .2)",
    fontWeight: "bold",
    textTransform: "uppercase",
    textAlign: "center",
    paddingLeft: "40px",
    left: "-25px",
    top: "30px",
    transform: "rotate(45deg)"
  }

}));

const MembershipCard = props => {
  const classes = useStyles();
  return (
    <div className={classes.card}>
      {(props.membership.MembershipPackageID === props.activePackageID) &&
        <div id="ActiveMembershipRibbonDiv" item xs={12} style={{ position: 'relative' }}>
          <div className={classes.ribbon}>
            <Typography variant='body1' component="span" className={classes.ribbonSpan}>
              Active
            </Typography>
          </div>
        </div>
      }

      <Card className={(props.membership.MembershipPackageID === props.activePackageID ? classes.highlightActiveMembershipPackage : '')}>
        <CardHeader className={classes.tourheaderbox}
          title={props.membership.PackageName}
          titleTypographyProps={{ color: "inherit" }}
        />
        <CardContent>
          <Grid
            container
            spacing={1}
          >
            <Grid
              item
              lg={6}
              md={12}

            >
              <img alt="ImageURL"
                src={genfunction.replaceEscapeCharacters(props.membership.ImageURL && props.membership.ImageURL != "" ? props.membership.ImageURL : MembershipPackageDefaultImage)}
                className={classes.img} />

            </Grid>

            <Grid container item
              lg={6}
              md={12}
              alignContent='flex-start'
            >
              <Grid
                item
                xs={12}
              >
                <Typography component="p" color="textSecondary">
                  {ReactHtmlParser(genfunction.replaceEscapeCharacters(props.membership.Description))}
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
              >
                <Button className={classes.btnAlign} variant="contained" color="primary" onClick={() => props.JoinOrRenewMembershipPage(props.membership)}>Select</Button>
              </Grid>
            </Grid>

          </Grid>


        </CardContent>
      </Card>
    </div >
  );
};

export default MembershipCard;
